let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cy8kO")).then(() => parcelRequire('448Uu'));